// src/App.js
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer'; // already imported
import RecommendedPage from './pages/RecommendedPage';
import TrendingPage from './pages/TrendingPage';
import MoviesPage from './pages/MoviesPage';
import SeriesPage from './pages/SeriesPage';
import ActorsPage from './pages/ActorsPage';
import FavoritesPage from './pages/FavoritesPage';
import MovieModal from './components/MovieModal';
import SeriesModal from './components/SeriesModal';
import TrailerModal from './components/TrailerModal';
import Watch from './pages/Watch';
import WatchTwo from './pages/WatchTwo';
import WatchThree from './pages/WatchThree';
import './styles/main.css';

function App() {
  const [activeModal, setActiveModal] = useState(null);
  const [modalContent, setModalContent] = useState(null);
  const [trailerKey, setTrailerKey] = useState('');

  const showContentModal = (content, type) => {
    setModalContent({ type, data: content });
    setActiveModal(type);
  };

  const showTrailerModal = (key) => {
    setTrailerKey(key);
    setActiveModal('trailer');
  };

  const closeModal = () => {
    setActiveModal(null);
    setModalContent(null);
    setTrailerKey('');
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (activeModal && e.target.classList.contains('modal-backdrop')) {
        closeModal();
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return () => document.removeEventListener('click', handleOutsideClick);
  }, [activeModal]);

  useEffect(() => {
    document.body.style.overflow = activeModal ? 'hidden' : 'auto';
  }, [activeModal]);

  return (
    <Router>
      <div className="app">
        <Navbar showContentModal={showContentModal} />
        
        <div className="page-content">
          <Routes>
            <Route path="/" element={<RecommendedPage showContentModal={showContentModal} />} />
            <Route path="/trending" element={<TrendingPage showContentModal={showContentModal} />} />
            <Route path="/movies" element={<MoviesPage showContentModal={showContentModal} />} />
            <Route path="/series" element={<SeriesPage showContentModal={showContentModal} />} />
            <Route path="/actors" element={<ActorsPage />} />
            <Route path="/favorites" element={<FavoritesPage />} />
            <Route path="/watch/:id" element={<Watch />} />
            <Route path="/alt-watch/:id" element={<WatchTwo />} />
            <Route path="/alt-watch-two/:id" element={<WatchThree />} />
          </Routes>
        </div>

        {/* Modals */}
        {activeModal === 'movie' && modalContent && (
          <MovieModal movieData={modalContent.data} closeModal={closeModal} showTrailerModal={showTrailerModal} />
        )}
        {activeModal === 'series' && modalContent && (
          <SeriesModal seriesData={modalContent.data} closeModal={closeModal} showTrailerModal={showTrailerModal} />
        )}
        {activeModal === 'trailer' && (
          <TrailerModal trailerKey={trailerKey} closeModal={closeModal} />
        )}

        {/* Footer - now at the bottom */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;